import { getStatesForCountry } from 'features/regions/api';

import createRegionOptionElement from './createRegionOptionElement';

function populateStateProvince ($stateSelect, $countrySelect, selectedStateValue = '-1') {

	const countrySelectElement = $countrySelect[0];
	const stateSelectElement = $stateSelect[0];
	const countryCode = countrySelectElement.value;

	return getStatesForCountry(countryCode)
		.then((states) => {

			// clear previous states
			stateSelectElement.innerHTML = '';
			stateSelectElement.appendChild(
				createRegionOptionElement({
					label: 'Select a State/Province',
					value: '-1'
				})
			);

			Object.keys(states).forEach((key) => {

				const label = states[key];
				const value = key;
				const isSelected = key === selectedStateValue;
				const option = createRegionOptionElement({
					value,
					label,
					isSelected,
					isDefaultSelected: isSelected
				});
				stateSelectElement.appendChild(option);

			});

		})
		.catch(() => {

			const noStateOption = createRegionOptionElement({ label: '', value: '', isSelected: true });
			stateSelectElement.appendChild(noStateOption);

		});

}

export default populateStateProvince;
